module.exports = __webpack_public_path__ + "img/admin.8d382863.png";